import Seo from "../components/Seo";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-xl font-extrabold text-brand-navy">{title}</h2>
    <div className="mt-2 space-y-3 text-brand-muted leading-relaxed">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <>
      <Seo title="Terms & Conditions | Car To Cash" description="The terms and conditions governing quotes, inspections and vehicle purchases by Car To Cash." canonical="https://cartocash.com.au/terms" />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-16" data-testid="terms-page">
        <h1 className="font-display text-4xl font-black text-brand-navy">Terms &amp; Conditions</h1>
        <p className="mt-3 text-sm text-brand-muted">Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="Quotes and valuations">
          <p>Any valuation provided online or by phone is an estimate based on the information you supply. A final firm offer is made only after an in-person inspection. Offers are valid for 7 days from the date of inspection.</p>
        </Section>
        <Section title="Inspections">
          <p>Final offers are subject to physical inspection of the vehicle. We reserve the right to adjust or withdraw an offer if the vehicle's condition, history or documentation differs materially from what was disclosed.</p>
        </Section>
        <Section title="Ownership and identification">
          <p>You must be the legal owner of the vehicle (or authorised to sell it) and provide valid photo identification. We purchase privately-owned vehicles only and verify that vehicles are not recorded as stolen. Vehicles on finance may be purchased subject to a lender payout.</p>
        </Section>
        <Section title="Payment">
          <p>Payment is made on the spot by cash or EFT / bank transfer upon completion of the sale and paperwork. Bank transfer timing may depend on your financial institution.</p>
        </Section>
        <Section title="Removal">
          <p>Free removal is included with vehicles we purchase within our service area. Access to the vehicle must be reasonably safe and lawful for our team to complete removal.</p>
        </Section>
        <Section title="Liability">
          <p>To the extent permitted by law, our liability is limited to the value of the transaction. Nothing in these terms excludes rights you have under the Australian Consumer Law.</p>
        </Section>
        <Section title="Contact">
          <p>Questions about these terms? Contact us at info@cartocash.com.au or 0431 206 206.</p>
        </Section>
      </section>
    </>
  );
}
